import { Drawer } from "@portal/BaseComponents/Drawer/AntDrawer";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { SkeletonInput } from "@portal/BaseComponents/Skeleton/AntSkeleton";
import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import { FormHeader } from "@portal/BaseComponents/UI/FormArea/FormHeader";
import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { AppPageParams } from "@portal/lib/router/constants/page-info";
import { usePageNavigate } from "@portal/lib/router/hooks/usePageNavigae";
import { usePaymentDetailsQuery } from "@portal/queries/payment-query";
import { Fragment } from "react";
import { useParams } from "react-router-dom";
import { PaymentDetailsComp } from "./Details/PaymentDetails";
import { PaymentDetailsViewProps } from "./type";

const PaymentIcon = (
  <Icon icon={["far", "credit-card"]} color="var(--green-6)" />
);
const t = {
  title: "Payment Details",
};
function PaymentDetailsView(props: PaymentDetailsViewProps) {
  const {
    id,
    open,
    header,
    headerTitle = t.title,
    actionButton,

    // footer,
    onClose,
  } = props;

  const { open: commentOpen } = useOpen({ open: false });
  const navigate = usePageNavigate();
  const { customer_id } = useParams<AppPageParams>();
  const { data, isLoading } = usePaymentDetailsQuery(id);

  function handleClose() {
    onClose?.();
    navigate({
      appPage: "PAYMENTS",
      pathParams: {
        customer_id: customer_id as string,
      },
    });
  }
  const HeaderTitle = (
    <>
      {isLoading ? (
        <SkeletonInput />
      ) : (
        <Flex align="center" justify="center" space="16">
          {PaymentIcon}
          <TypographyText style={{ fontWeight: "var(--fs-regular)" }} fs="16">
            {`${headerTitle} - #${data ? data.reference_no : "-"}`}
          </TypographyText>
        </Flex>
      )}
    </>
  );
  const ActionArea = (
    <Flex>
      {actionButton?.map((action) => (
        <Fragment key={action.id}>{action.component}</Fragment>
      ))}
    </Flex>
  );
  const Header = header ? (
    header
  ) : (
    <FormHeader
      mode="drawer"
      onClose={handleClose}
      title={HeaderTitle}
      extra={ActionArea}
    />
  );

  // const Footer = footer ? (
  //   footer
  // ) : (
  //   <Comment
  //     type="BOX"
  //     buttonProps={{ actionButton: "gf-1" }}
  //     onOpenChange={handleOpenChange}
  //   />
  // );

  return (
    <Drawer
      title={Header}
      open={open}
      // footer={Footer}
      width={640}
      styles={{
        wrapper: {
          background: "var(--gray-1)",
          boxShadow: "var(--shadow-4)",
          height: "var(--drawer-height)",
        },
        header: { padding: 0 },
        footer: {
          padding: commentOpen ? 0 : "var(--space-12) var(--space-24)",
          backgroundColor: "var(--gray-2)",
        },
      }}
      mask={false}
      getContainer={false}
    >
      <PaymentDetailsComp data={data} loading={isLoading} />
    </Drawer>
  );
}

export { PaymentDetailsView };
